export default "__VITE_ASSET__BtZ7URQS__"